export enum STEPS {
  'SELECT' = 0,
  'CONFIGURE' = 1,
  'REVIEW' = 2,
}
